import axios from 'axios'
import Vue from 'vue'

let isShowError;//当前请求显示错误弹窗
let instance = axios.create({
	baseURL: process.env.BASE_API,
	timeout: 10000,
  	withCredentials: false,
})

// // request拦截器

instance.interceptors.request.use(config => {

  isShowError = typeof config.isShowError === 'undefined' ? true : config.isShowError;

  return config
}, error => {
  // Do something with request error
  // console.log(error) // for debug
  return Promise.reject(error)
})

// // respone拦截器
instance.interceptors.response.use(
  response => {

    const res = response.data

    if (response.status !== 200) {

      return Promise.reject('error')
    } else {
      if (response.config.method === 'post'){
          if (response.data.successed) {
            return response.data;
          } else {
              
            if (isShowError) {
              Vue.$vux.alert.show({
                content: `<span>${ response.data.msg || '请求失败' }</span>`,
              })
            }
            
             return Promise.reject(response.data);
          }
      } else {
        return response.data;
      }
     
      
    }
  },
  error => {
    // console.log('err' + error)// for debug
    Vue.$vux.toast.show({
      type: 'text',
      text: '请求失败'
    });
    return Promise.reject(error)
  }
)


export default instance;


// WEBPACK FOOTER //
// ./src/utils/axios.js